<div class="wrapper-content game-wrapper-full"
[class.color-1]="url=='incendios-forestales'"
[class.color-2]="url=='humedales'"
[style.background]="(url=='incendios-forestales')?'url('+'/assets/games/fuego-04.jpg'+')':'url('+'/assets/games/humedales-03.jpg'+')'">

  <div class="game-header" *ngIf="cont">
    <h5 class="legend">{{url}}</h5>
    <h1 class="title">{{cont.title.es}}</h1>
    <a class="btn-back" (click)="route.goBack()" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)"/>
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1" transform="translate(0 36.062) rotate(-45)" fill="#fff"/>
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1" transform="translate(3.606 0) rotate(45)" fill="#fff"/>
          </g>
        </g>
      </svg>
    </a>
  </div>
  <div class="container-fluid game-content" style="padding: 30px 15px !important;">


    <app-widgets-v2 *ngIf="cont" [data]="cont"></app-widgets-v2>

  </div>
</div>
